/**
 * Uprosal Brand Logo
 * 
 * Per design.md: No emojis as logos. Use lucide-react icon.
 * Uses Sparkles icon as brand mark.
 */

import { Sparkles } from 'lucide-react';
import { cn } from '../../lib/utils';

interface LogoProps {
    size?: 'sm' | 'md' | 'lg';
    showText?: boolean;
    className?: string;
}

const sizeMap = {
    sm: { container: 32, icon: 18 },
    md: { container: 48, icon: 24 },
    lg: { container: 64, icon: 32 },
};

const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
};

export function Logo({ size = 'md', showText = true, className }: LogoProps) {
    const { container, icon } = sizeMap[size];

    return (
        <div className={cn('flex items-center gap-2', className)}>
            <div
                className="flex items-center justify-center rounded-lg bg-primary text-primary-foreground shadow-sm shrink-0"
                style={{ width: container, height: container }}
            >
                <Sparkles size={icon} strokeWidth={2} />
            </div>
            {showText && (
                <span className={cn('font-bold text-foreground', textSizes[size])}>
                    Uprosal
                </span>
            )}
        </div>
    );
}
